<template>
  <nav
    class="w-full bg-white border-b border-grayLight rounded-tl-[20px] h-[56px] px-8 flex justify-between items-center font-inter"
  >
    <div class="flex space-x-3 items-center">
      <img
        src="@/assets/dashboard/graph-1.svg"
        alt="Company Logo"
        class="h-5"
      />
      <img
        src="@/assets/dashboard/chevron-right.svg"
        alt="Chevron icon"
        class="h-4"
      />
      <p
        class="font-medium text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-md"
      >
        {{ currentPageName }}
      </p>
      <template v-if="selectedProjectName">
        <img
          src="@/assets/dashboard/chevron-right.svg"
          alt="Chevron icon"
          class="h-4"
        />
        <router-link
          :to="{
            name: 'ProjectDetails',
            params: { projectId: $route.params.projectId },
          }"
          class="flex items-center space-x-2 text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-md cursor-pointer hover:bg-[#d0d3da]"
        >
          {{ selectedProjectName }}
        </router-link>
      </template>
      <template v-if="isActivityPage">
        <img
          src="@/assets/dashboard/chevron-right.svg"
          alt="Chevron icon"
          class="h-4"
        />
        <p
          class="font-medium text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-md"
        >
          Recent Activity
        </p>
      </template>
      <template v-if="isProjectAssetsPage">
        <img
          src="@/assets/dashboard/chevron-right.svg"
          alt="Chevron icon"
          class="h-4"
        />
        <router-link
          :to="{
            name: 'ProjectAssets',
            params: { projectId: $route.params.projectId },
          }"
          class="flex items-center space-x-2 text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-md cursor-pointer hover:bg-[#d0d3da]"
        >
          Assets
        </router-link>
      </template>
    </div>

    <div class="flex space-x-6 items-center">
      <div class="relative" ref="dropdown" @click="stopEventPropagation">
        <button
          @click="toggleRolesDropdown"
          :class="[
            'flex gap-1 items-center border py-1 px-4 rounded-[100px] focus:outline-none',
            getRoleColors(currentRole).border,
          ]"
        >
          <p
            :class="[
              'font-medium text-[12px] truncate overflow-hidden whitespace-nowrap',
              getRoleColors(currentRole).text,
            ]"
          >
            {{ capitalize(currentRole) }}
          </p>
            <img
              :src="getRoleIconPath('arrow', currentRole)"
              alt="Logo"
              class="h-4 w-4"
            />
          <!-- <img
            src="@/assets/users/chevron-down.svg"
            alt="Logo"
            :class="['h-4 w-4', getRoleColors(currentRole).text]"
            :style="{ filter: getIconFilter(currentRole) }"
          /> -->
          <img
            v-if="isExpanded"
            src="@/assets/projects/arrow-left.svg"
            alt="Logo"
            :class="['h-2 w-2', getRoleColors(currentRole).text]"
            :style="{ filter: getIconFilter(currentRole) }"
          />

        </button>

        
      </div>

      <div class="h-6 w-[1px] bg-grayLight"></div>
      <div class="flex items-center space-x-3">
        <!-- <div
          class="w-8 h-8 bg-[#FFFFFF] border border-grayLight rounded-full flex justify-center items-center"
        >
          <img
            src="@/assets/dashboard/notification.svg"
            alt="Company Logo"
            class="h-[18px]"
          />
        </div> -->
        <!-- <router-link :to="{ name: 'Profile' }" class="flex items-center">
            <UserAvatar :fullName="fullName" />
          </router-link> -->

        <div class="relative" ref="dropdown" @click="stopEventPropagation">
          <button
            @click="toggleDropdown"
            class="flex items-center focus:outline-none"
          >
            <div v-if="user.profile_picture" class="flex items-center">
              <img
                v-if="user.profile_picture"
                :src="user.profile_picture"
                alt="Profile Picture"
                class="w-10 h-10 rounded-full object-cover"
              />
            </div>
            <div v-else class="flex items-center">
              <UserAvatar
                :fullName="fullName"
                class="w-[32px] h-[32px] rounded-full bg-[#A3DB7D]"
              />
            </div>
          </button>

          <div
            v-if="dropdownOpen"
            class="absolute right-0 mt-2 text-[14px] w-72 bg-white border border-gray-200 rounded-md shadow-lg z-50"
          >
            <div
              class="flex gap-3 px-4 py-4 whitespace-nowrap border border-grayLight"
            >
              <router-link
                v-if="user.profile_picture"
                :to="{ name: 'Profile' }"
                class="flex items-center"
              >
                <img
                  v-if="user.profile_picture"
                  :src="user.profile_picture"
                  alt="Profile Picture"
                  class="w-10 h-10 rounded-full object-cover"
                />
              </router-link>
              <router-link
                v-else
                :to="{ name: 'Profile' }"
                class="flex items-center"
              >
                <UserAvatar
                  :fullName="fullName"
                  class="w-[40px] h-[40px] bg-[#A3DB7D]"
                />
              </router-link>

              <div class="max-w-[200px]">
                <p
                  class="font-medium text-bodyText truncate overflow-hidden whitespace-nowrap"
                >
                  {{ capitalize(user.first_name) }}
                  {{ capitalize(user.last_name) }}
                </p>
                <p
                  class="text-grayDark truncate overflow-hidden whitespace-nowrap"
                >
                  {{ user.email }}
                </p>
              </div>
            </div>
            <div>
              <router-link
                :to="{ name: 'Profile' }"
                class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                View profile
              </router-link>
              <router-link
                :to="{ name: 'Settings' }"
                class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Settings
              </router-link>
              <router-link
                :to="{ name: 'Settings', query: { section: 'notifications' } }"
                class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Notification settings
              </router-link>

              <router-link
                v-if="isInvestor"
                :to="{ name: 'InvestmentHistory' }"
                class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Investment history
              </router-link>
              <!-- <div v-if="!isAdmin">
                <button
                  @click="toggleExpand"
                  class="flex items-center gap-2 px-6 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                >
                  Switch account type
                  <img
                    v-if="!isExpanded"
                    src="@/assets/dashboard/Vector.svg"
                    alt="Logo"
                    class="h-2 w-2"
                  />
                  <img
                    v-if="isExpanded"
                    src="@/assets/projects/arrow-left.svg"
                    alt="Logo"
                    class="h-2 w-2"
                  />
                </button>

                <div v-if="isExpanded" class="mt-2 space-y-2 px-6">
                  <p
                    v-for="role in availableAccountTypes"
                    :key="role"
                    class="block text-[12px] text-gray-700 hover:bg-gray-100 py-1"
                    @click.prevent="switchAccountType(role)"
                  >
                    {{ role.charAt(0).toUpperCase() + role.slice(1) }}
                  </p>
                </div>
              </div> -->
              <button
                @click="logoutUser"
                class="block w-full text-left px-6 py-2 mb-4 text-sm text-gray-700 hover:bg-gray-100"
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import UserAvatar from "./auth/UserAvatar.vue";
import apiClient from "@/axios";
import eventBus from "@/eventBus";

export default {
  name: "NavbarComponent",
  components: {
    UserAvatar,
  },
  data() {
    return {
      user: {}, // Initialize as an empty object
      projectName: null,
      projectId: null,
      dropdownOpen: false,
      rolesDropdownOpen: false,

      isExpanded: false,
      accountTypes: [
        { name: "Investor", value: "investor" },
        { name: "Talent", value: "talent" },
        { name: "Manager", value: "manager" },
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    fullName() {
      if (!this.user || (!this.user.first_name && !this.user.last_name)) {
        return "";
      }
      return `${this.user.first_name || ""} ${
        this.user.last_name || ""
      }`.trim();
    },
    currentPageName() {
      return this.$route.meta.label || "Page";
    },
    isActivityPage() {
      return this.$route.name === "ActivityData";
    },
    isProjectAssetsPage() {
      return this.$route.name === "ProjectAssets";
    },
    selectedProjectName() {
      return ["ProjectDetails", "ActivityData", "ProjectAssets"].includes(
        this.$route.name
      )
        ? this.projectName
        : null;
    },
    activeSection() {
      return this.$route.query.section || "general"; // Default to 'general' if no query provided
    },
    userRoles() {
      return this.$store.state.availableRoles || [];
    },

    currentRole() {
      // This should match wherever your store actually stores the current role after switching
      return this.$store.state.role || this.$store.getters.currentRole;
    },

    // Filter roles to display in dropdown
    availableAccountTypes() {
      // const standardRoles = ["investor", "talent", "manager", "admin"];
      const standardRoles = ["investor", "talent", "admin"];

      const userRoles = this.$store.state.availableRoles || [];

      // Filter out the current role - only show other available roles
      return standardRoles.filter(
        (role) => userRoles.includes(role) && role !== this.currentRole
      );
    },
  },
  watch: {
    "$route.params.projectId": "fetchProjectName", // Re-fetch the project name when the route changes

    // Watch for role changes in the store
    "$store.state.role": {
      handler(newRole, oldRole) {
        if (newRole !== oldRole && newRole) {
          console.log("User role changed from", oldRole, "to", newRole);
          // Fetch updated user data when role changes
          this.fetchCurrentUser();
          this.fetchProjectName();
        }
      },
      immediate: false,
    },
  },

  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    toggleRolesDropdown() {
      this.rolesDropdownOpen = !this.rolesDropdownOpen;
    },
    closeRolesDropdown() {
      this.rolesDropdownOpen = false;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    stopEventPropagation(event) {
      event.stopPropagation();
    },
    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    async fetchCurrentUser() {
      try {
        const response = await apiClient.post("/current_user");
        this.user = response.data.user || {}; // Safely set user data
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    emitOpenCreateProjectModal() {
      eventBus.emit("openCreateProjectModal");
    },
    emitOpenAddProjectMemberModal() {
      eventBus.emit("openAddProjectMemberModal", {
        projectId: this.projectId,
        projectName: this.projectName,
      });
    },
    async fetchProjectName() {
      const validRoutes = ["ProjectDetails", "ActivityData"];
      if (validRoutes.includes(this.$route.name)) {
        try {
          const projectId = this.$route.params.projectId;
          console.log("Fetching project name for ID:", projectId); // Debugging log
          const response = await apiClient.get(`/web/projects/${projectId}`);
          console.log("Project Response:", response.data); // Debugging log
          this.projectId = projectId;
          this.projectName =
            response.data.data.project_name || "Unknown Project";
        } catch (error) {
          console.error("Error fetching project name:", error);
          this.projectName = "Unknown Project";
        }
      }
    },

    async logoutUser() {
      try {
        this.$store.commit("logout");
        console.log("User logged out and store cleared");

        await this.$router.replace({ name: "Login" });
      } catch (error) {
        console.error("Error logging out:", error);
      }
    },
    getRoleIcon(role) {
      try {
        return require(`@/assets/dashboard/${role.toLowerCase()}-icon.svg`);
      } catch (error) {
        return require("@/assets/dashboard/talent-icon.svg");
      }
    },
    getRoleIconPath(iconName, role) {
      try {
        return require(`@/assets/users/${role.toLowerCase()}-${iconName}.svg`);
      } catch (error) {
        // Fallback to default icon if role-specific version doesn't exist
        try {
          return require(`@/assets/users/${iconName}.svg`);
        } catch (fallbackError) {
          // Fallback
          return require(`@/assets/users/chevron-down.svg`);
        }
      }
    },
    getRoleColors(role) {
      const colors = {
        investor: {
          text: "text-[#14C100]",
          border: "border-[#14C100]",
        },
        talent: {
          text: "text-[#0000FF]",
          border: "border-[#0000FF]",
        },
        manager: {
          text: "text-[#FBC600]",
          border: "border-[#FBC600]",
        },
        admin: {
          text: "text-red-600",
          border: "border-red-600",
        },
      };
      return colors[role] || colors.talent;
    },
  },
  // created() {
  //   this.fetchCurrentUser();
  //   this.fetchProjectName();
  // },
  created() {
    this.fetchCurrentUser();

    if (this.$store.getters.roleLoaded) {
      this.loading = true;
      Promise.all([
        // this.fetchTalents(),
        // this.fetchProjects(),
        // this.fetchUsers()
      ]).finally(() => {
        this.loading = false;
      });
    } else {
      // Watcher to detect when role is loaded
      const unwatch = this.$store.watch(
        (state) => state.roleLoaded,
        (newValue) => {
          if (newValue) {
            this.loading = true;
            Promise.all([
              // this.fetchTalents(),
              // this.fetchProjects(),
              // this.fetchUsers()
            ]).finally(() => {
              this.loading = false;
              unwatch(); // Remove watcher once executed
            });
          }
        }
      );

      if (!this.$store.state.role) {
        this.$store.dispatch("initializeStore");
      }
    }
  },
  // mounted() {
  //   document.addEventListener("click", this.closeDropdown);
  // },

  // beforeUnmount() {
  //   // Clean up the event listener
  //   document.removeEventListener("click", this.closeDropdown);
  // },

  mounted() {
    document.addEventListener("click", this.closeDropdown);
    document.addEventListener("click", this.closeRolesDropdown);
  },
  beforeUnmount() {
    // Clean up the event listener
    document.removeEventListener("click", this.closeDropdown);
    document.removeEventListener("click", this.closeRolesDropdown);
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
